import React from 'react'
import Dropzone from 'react-dropzone'
import S3 from 'react-aws-s3'
import { useDispatch, useSelector } from 'react-redux'
import Button from 'src/components/atoms/Button'
import css from './shared.module.scss'
import { toast } from 'react-toastify'
import { nextStep, previousStep, setBusinessInfo } from 'src/slices/signup'
import { updateBusinessInfo } from 'src/slices/info'

export default function StoreMedia() {
	const dispatch = useDispatch()
	const { user, token } = useSelector(state => state.signup)
	const { logo, photos } = useSelector(state => state.signup.businessInfo)
	const config = {
		bucketName: 'carty-app',
		region: 'us-east-1',
		accessKeyId: 'AKIAQHLGGFVPLOMRLX5O',
		secretAccessKey: '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',
		s3Url: 'https://carty-app.s3.amazonaws.com' /* optional */,
	}
	const ReactS3Client = new S3(config)
	// const handleDrop = (acceptedFiles, id) => {
	// 	const uploadImage = ReactS3Client.uploadFile(acceptedFiles[0])
	// 		.then(data => {
	// 			dispatch(setBusinessInfo({ photos: { ...photos, [id]: data.location } }))
	// 		})

	// 	handleToast(uploadImage, {
	// 		isSuccess: { message: 'Image Uploaded!' },
	// 		isError: { message: 'Image could not be uploaded, please try again.' },
	// 		isLoading: { message: `Uploading...` },
	// 	})
	// }

	const handleDrop = (acceptedFiles, id) => {
		if (!['image/jpeg', 'image/png'].includes(acceptedFiles[0]?.type)) {
			toast.warning('Only .png and .jpg files are accepted')
			return
		}

		// const toastId = acceptedFiles[0]?.name
		toast.loading('Uploading...')

		ReactS3Client.uploadFile(acceptedFiles[0])
			.then(image => {
				dispatch(setBusinessInfo({ photos: { ...photos, [id]: image.location } }))
				toast.dismiss()
			})
			.catch(() => {
				// toast.dismiss()
				toast.error('Image could not be uploaded, please try again.')
			})
	}

	const handleNext = () => {
		if (photos.first || photos.second) {
			const data = {
				businessPhotos: Object.values(photos),
			}
			dispatch(
				updateBusinessInfo({
					data,
					fieldset: 'media',
					signupToken: token,
					merchantId: user.id,
				})
			)
				.unwrap()
				.then(() => dispatch(nextStep()))
				.catch(() =>
					toast.error(
						'There was an error while updating Business Photos, please try again'
					)
				)
		} else {
			toast.warning('At least one business image is required')
		}
	}
	const handleBack = () => {
		dispatch(previousStep())
	}
	const handleSkip = () => {
		dispatch(nextStep())
	}
	return (
		<div>
			<Dropzone
				accept={['image/jpeg', 'image/png']}
				onDrop={acceptedFiles => handleDrop(acceptedFiles, 'first')}>
				{({ getRootProps, getInputProps }) => (
					<div
						{...getRootProps()}
						className={css['box']}>
						<input {...getInputProps()} />
						<div
							className={`
                            ${photos.first ? '' : css['image-upload-box']} 
                            `}>
							{photos.first ? (
								<img
									src={photos.first}
									className={css['uploaded-image']}
								/>
							) : (
								<i className='fad fa-camera' />
							)}
						</div>
						<span>Storefront Photo</span>
					</div>
				)}
			</Dropzone>

			<Dropzone
				accept={['image/jpeg', 'image/png']}
				onDrop={acceptedFiles => handleDrop(acceptedFiles, 'second')}>
				{({ getRootProps, getInputProps }) => (
					<div
						{...getRootProps()}
						className={css['box']}>
						<input {...getInputProps()} />
						<div
							className={`
                            ${photos.second ? '' : css['image-upload-box']} 
                            `}>
							{photos.second ? (
								<img
									src={photos.second}
									className={css['uploaded-image']}
								/>
							) : (
								<i className='fad fa-camera' />
							)}
						</div>
						<span>Store Inside Photo</span>
					</div>
				)}
			</Dropzone>

			<div className={css['buttons']}>
				<Button
					label='Back'
					variant='tertiary'
					color='white'
					iconLeft='fa fa-chevron-left'
					action={handleBack}
				/>

				<Button
					label='Skip'
					variant='tertiary'
					color='white'
					iconRight='fa fa-chevron-right'
					action={handleSkip}
				/>
				<Button
					label='Continue'
					variant='primary'
					color='white'
					iconRight='fa fa-chevron-right'
					action={handleNext}
				/>
			</div>
		</div>
	)
}